import { useMemo, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, CURRENCIES } from "@/lib/api";
import { Panel, act, useLoad } from "@/components/common";

export function FxRiskSettings({ data, canEdit, reload }) {
  const [def, setDef] = useState(data.fx_risk_pct ?? 5);
  const [by, setBy] = useState(data.fx_risk_by_currency || {});
  const rc = useLoad(() => api.get("/fx").then((r) => r.data.reporting_currency)).data;
  const others = useMemo(() => Object.entries(CURRENCIES).filter(([c]) => c !== rc), [rc]);
  const save = () => act(api.put("/settings", { fx_risk_pct: Number(def), fx_risk_by_currency: Object.fromEntries(Object.entries(by).filter(([, x]) => x !== "" && x != null).map(([k, x]) => [k, Number(x)])) }), "Currency risk thresholds saved").then((r) => r && reload());
  return (
    <Panel title="Currency risk thresholds" testid="fx-risk-settings">
      <p className="mb-3 text-xs text-slate-500">A project is flagged on the Portfolio page (and PMO alerted) when its converted forecast moves more than this between monthly rates. Leave a currency blank to use the default; set higher limits for more volatile markets.</p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <div className="space-y-1"><label className="text-xs font-medium">Default threshold (%)</label>
          <Input type="number" step="0.5" min="0.1" disabled={!canEdit} data-testid="setting-fx_risk_pct" value={def} onChange={(e) => setDef(e.target.value)} /></div>
        {others.map(([c, [, n]]) => (
          <div key={c} className="space-y-1"><label className="text-xs font-medium">{c} — {n} (%)</label>
            <Input type="number" step="0.5" min="0.1" disabled={!canEdit} placeholder={`default (${def}%)`} data-testid={`setting-fx-risk-${c}`} value={by[c] ?? ""} onChange={(e) => setBy({ ...by, [c]: e.target.value })} /></div>
        ))}
      </div>
      {canEdit && <Button className="mt-4" data-testid="save-fx-risk-btn" onClick={save}>Save thresholds</Button>}
    </Panel>
  );
}
